import Optimize from './Optimize';

export default Optimize;
